import { useEffect, useState } from 'react'
import { OutboundLink } from 'react-ga'
import PleaseSupportUs from '../components/PleaseSupportUs'
import cardConduit320x50 from '../assets/ads/cardConduit320x50.jpg'
import cardConduit728x90 from '../assets/ads/cardConduit728x90.jpg'
import classNames from 'classnames'
import { isPatron } from '../util/helpers'
import styles from '../styles/Leaderboard.module.scss'
import useDarkMode from 'use-dark-mode'
import { useSelector } from 'react-redux'

const Leaderboard = () => {
  const darkMode = useDarkMode(false)
  const profile = useSelector((state) => state.firebase.profile)
  const [adRoll, setAdRoll] = useState(Math.random() > 1) // 1 = disabled

  useEffect(() => {})

  if (isPatron(profile)) return null

  if (!adRoll) {
    return (
      <div
        className={classNames(styles.leaderboard, {
          [styles.dark]: darkMode.value,
        })}
      >
        <PleaseSupportUs always height={90} width={728} />
      </div>
    )
  }

  return (
    <div
      className={classNames(styles.leaderboard, {
        [styles.dark]: darkMode.value,
      })}
    >
      <div className='d-block d-sm-none'>
        <OutboundLink
          eventLabel='https://cardconduit.com/edhrec'
          target='_blank'
          to='https://cardconduit.com/edhrec'
        >
          <img alt='Card Conduit' src={cardConduit320x50} />
        </OutboundLink>
      </div>
      <div className='d-none d-sm-block'>
        <OutboundLink target='_blank' to='https://cardconduit.com/edhrec'>
          <img
            alt='Card Conduit'
            eventLabel='https://cardconduit.com/edhrec'
            src={cardConduit728x90}
          />
        </OutboundLink>
      </div>
    </div>
  )
}

export default Leaderboard
